export const TOASTER_SERVER_ERROR_MSG = 'Wystąpił błąd serwera. Spróbuj ponownie.';
export const TOASTER_FILE_ERROR_MSG = 'Wystąpił błąd pliku. Spróbuj ponownie.';
export const TOASTER_ERROR_OCCURED_MSG = 'Wystąpił błąd.';
export const TOASTER_ATTACH_FILE_MSG = 'Proszę załączyć plik.';
export const TOASTER_NO_ACTION_SELECTED_MSG = 'Proszę zaznaczyć przynajmniej jedną akcję.';
export const TOASTER_NO_EBP_IN_ORDER_MSG = 'Zlecenie nie posiada numeru EBP.';
